import { render, staticRenderFns } from "./RegisterModal.vue?vue&type=template&id=7ac44c0a&scoped=true&"
import script from "./RegisterModal.vue?vue&type=script&lang=js&"
export * from "./RegisterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac44c0a",
  null
  
)

export default component.exports